import { VStack, HStack, Text } from '@chakra-ui/react';
import { HiDocument } from 'react-icons/hi2';
import dayjs from 'dayjs';
import COMPONENT_REGISTRY from '@/components/chat/messages/componentRegistry';

const renderBoldText = (text) => {
    if (!text) return null;
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return <span key={i}>{part}</span>;
    });
};

const BotMessage = ({ message, colors, onItemPress }) => {
    const isFile = message.type === 'file' || message.type === 'image';

    if (message.type === 'api') {
        const parts = message.text?.split(/(\{#\w+\})/g) ?? [];
        return (
            <VStack gap={1} alignItems="flex-start" w="100%">
                {parts.map((part, i) => {
                    const match = part.match(/^\{(#\w+)\}$/);
                    if (match) {
                        const Component = COMPONENT_REGISTRY[match[1]];
                        if (Component && Array.isArray(message.result) && message.result.length > 0) {
                            return (
                                <VStack key={i} gap={2} w="100%" my={1}>
                                    {message.result.map((item, idx) => (
                                        <Component
                                            key={item.id ?? idx}
                                            item={item}
                                            number={idx + 1}
                                            onPress={() => onItemPress?.(String(idx + 1))}
                                        />
                                    ))}
                                </VStack>
                            );
                        }
                        return null;
                    }
                    if (!part) return null;
                    return (
                        <Text key={i} fontSize="sm" color={colors.textPrimary} whiteSpace="pre-wrap" lineHeight="1.6" textAlign="left">
                            {renderBoldText(part)}
                        </Text>
                    );
                })}
                <Text fontSize="xs" color={colors.dateText}>
                    {dayjs(message.timestamp).format('HH:mm')}
                </Text>
            </VStack>
        );
    }

    return (
        <VStack gap={1} alignItems="flex-start" w="100%">
            {message.type === 'image' ? (
                <img
                    src={message.content}
                    alt={message.filename}
                    style={{ maxWidth: '240px', maxHeight: '320px', borderRadius: '8px', display: 'block' }}
                />
            ) : isFile ? (
                <HStack gap={2}>
                    <HiDocument size={18} color={colors.textSecondary} />
                    <Text fontSize="sm" color={colors.textPrimary}>{message.filename}</Text>
                </HStack>
            ) : (
                <Text
                    fontSize="sm"
                    color={colors.textPrimary}
                    whiteSpace="pre-wrap"
                    lineHeight="1.6"
                    textAlign="left"
                >
                    {renderBoldText(message.text)}
                </Text>
            )}
            <Text fontSize="xs" color={colors.dateText}>
                {dayjs(message.timestamp).format('HH:mm')}
            </Text>
        </VStack>
    );
};

export default BotMessage;
